// extracted by mini-css-extract-plugin
export default {"notice":"U5lqTPrgeXTNp69c17Jk","pulse":"NlK_8nkwd4olObwQKJVE"};